<template>
	<div class="date-picker">
		<div class="date-picker__input" @click="openBox" ref="input"
			:class="{'date-picker__input--placeholder': date === ''}">
			{{dateText}}
		</div>
		<div
			class="date-picker__box"
			v-if="open"
			v-click-outside="closeBox"
			:style="{
				'top': top
			}">
			<div class="date-picker__box__header">
				<button type="button" class="date-picker__box__header__change-month" @click="changeMonth('previous')"><i class="fas fa-chevron-circle-left"></i></button>
				{{month.name}} {{month.year}}
				<button type="button" class="date-picker__box__header__change-month" @click="changeMonth('next')"><i class="fas fa-chevron-circle-right"></i></button>
			</div>
			<table>
				<tr>
					<th>M</th>
					<th>T</th>
					<th>W</th>
					<th>T</th>
					<th>F</th>
					<th>S</th>
					<th>S</th>
				</tr>
				<tr
					class="date-picker__week"
					v-for="(week, index) in monthWeeks"
					:key="index">
					<td
						@click="pickDate(day)"
						:class="{
							'date-picker__week__day--inactive-month':inactiveMonth(day),
							'date-picker__week__day--selected':selected(day)}"
						class="date-picker__week__day"
						v-for="(day, index) in week.days"
						:key="index">
						{{day.number}}
					</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
import DateService from '@/services/DateService'
export default {
	props: {
		date: String,
		placeholder: String
	},
	data () {
		return {
			month: '',
			open: false,
			top: 0
		}
	},
	methods: {
		openBox () {
			this.open = true
			if (!this.date) this.month = DateService.getFullMonth(new Date())
			else this.month = DateService.getFullMonth(new Date(this.date))
		},
		closeBox (event) {
			if (event.target !== this.$refs.input) this.open = false
		},
		setOffset () {
			const input = this.$refs.input
			let coords = input.getBoundingClientRect()
			this.top = coords.bottom + 'px'
		},
		changeMonth (dir) {
			if (dir === 'previous') {
				const date = this.month.start
				this.month = DateService.getFullMonth(new Date(date.setDate(date.getDate() - 1)))
			} else if (dir === 'next') {
				const date = this.month.end
				this.month = DateService.getFullMonth(new Date(date.setDate(date.getDate() + 1)))
			}
		},
		inactiveMonth (day) {
			return day.date.getMonth() !== this.month.index
		},
		selected (day) {
			return day.string === this.date
		},
		pickDate (day) {
			this.$emit('setDate', day)
			this.open = false
		}
	},
	computed: {
		monthWeeks () {
			var monthWeeks = []
			var date = this.month.start
			while (date <= this.month.end) {
				var week = DateService.getWeek(date)
				week.days = DateService.getWeekDays(week)
				monthWeeks.push(week)
				date = DateService.getNextMonday(date)
			}
			return monthWeeks
		},
		dateText () {
			return this.date ? new Date(this.date).format('F d') : this.placeholder
		}
	},
	beforeMount () {
		document.addEventListener('scroll', this.setOffset, true)
	},
	beforeDestroy () {
		document.removeEventListener('scroll', this.setOffset, true)
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_datepicker.scss";
</style>
